import { 
    Box,
    Group,
    Avatar,
    Text,
    Menu,
    UnstyledButton,
    useMantineTheme,
    useMantineColorScheme
} from '@mantine/core';
import { 
    IconLogout,
    IconSettings,
    IconWorld,
    IconHelpCircle,
    IconChevronRight,
    IconSun,
    IconMoonStars 
} from '@tabler/icons-react';
import { useAuth } from '@/lib/auth';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import getFirstLetters from '@/utils/string'

export type ProfileSummaryProps = {
    open: boolean;
}

export const ProfileSummary = ({ open }: ProfileSummaryProps) => {
    const { t, i18n } = useTranslation();
    const { user } = useAuth();
    const { logout } = useAuth();
    const theme = useMantineTheme();
    const { colorScheme, toggleColorScheme } = useMantineColorScheme();
    const dark = colorScheme === 'dark';

    if (!user) return null;

    async function handleDisconnect() {
        await logout();
    }

    async function handleLanguageSwitch() {
        const lang = i18n.language === 'en' ? "fr" : "en"
        i18n.changeLanguage(lang);
    }

    const userInfoComponent =   
        <Group>
            <div style={{ flex: 1, overflow: 'hidden'}}>
                    <Text size="sm" weight={500}>
                        {user.data.fullname}
                    </Text>
                    <Text size="xs" color="dimmed">
                        {user.username}
                    </Text>
            </div>
            <IconChevronRight size="1rem" />
        </Group>
    return (
        <Menu shadow="md" width={200} >
            <Menu.Target>
                <UnstyledButton
                    sx={{
                        display: 'block',
                        width: '100%',
                        padding: theme.spacing.xs,
                        borderRadius: theme.radius.sm,
                        color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,

                        '&:hover': {
                            backgroundColor:
                            theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
                        },
                    }}>
                    <Group>
                        {
                            user.data.logo.original 
                            ? <Avatar size={47} radius="xl" color="blue" src={user.data.logo.original} />
                            : <Avatar size={47} radius="xl" color="blue">{getFirstLetters(user.data.fullname)}</Avatar>
                        }
                        {
                            open &&
                            userInfoComponent
                        }
                    </Group>
                </UnstyledButton>
            </Menu.Target>
        
            <Menu.Dropdown>
                <Menu.Item 
                    onClickCapture={() => toggleColorScheme()} 
                    leftSection={ dark ? <IconSun size={14}/> : <IconMoonStars size={14} /> }>
                    {
                        dark ? t('theme.lightTheme') : t('theme.darkTheme')
                    }
                </Menu.Item>
                <Link to="mailto:support@studiocast.ca" style={{ textDecoration: 'none' }}>
                    <Menu.Item leftSection={<IconHelpCircle size={14} />}>{t('misc.help')}</Menu.Item>
                </Link>
                <Menu.Item onClickCapture={handleLanguageSwitch} leftSection={<IconWorld size={14} />}>{i18n.language === 'en' ? "FR" : "EN"}</Menu.Item>
                <Menu.Divider />
                <Menu.Item color='red' onClickCapture={handleDisconnect} leftSection={<IconLogout size={14}/> }>{t('action.disconnect')}</Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
}
